<template>
  <div>
    <b-modal id="modal-input-gaji" size="lg" centered title="Tambah Data Gaji Pokok" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group :label="$store.state.form.namaGaji" label-cols-md="3">
          <b-form-input :state="checkIfValid('namaGaji')" v-model="$v.dataGaji.namaGaji.$model" @keydown.enter.prevent="simpan()"></b-form-input>
        </b-form-group>
      </b-form>

      <b-form>
        <b-form-group :label="$store.state.form.nominalGaji" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nominalGaji')"
            v-model="$v.dataGaji.nominalGaji.$model"
            :placeholder="convert(dataGaji.nominalGaji)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <!-- 
    <b-form>
      <b-form-group :label="$store.state.form.nominalGajiBaru" label-cols-md="3">
        <b-form-input
          v-model="dataGaji.nominalGaji"
          :placeholder="convert(dataGaji.nominalGajiTahunDepan)"
          @keydown.enter.prevent="simpan()"
        ></b-form-input>
      </b-form-group>
    </b-form> 
    -->

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input-gaji')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid">
          {{ $store.state.form.simpan }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "modalInput",
  props: ["kategori", "unit"],
  data() {
    return {
      dataGaji: {
        namaGaji: "",
        nominalGaji: "",
        nominalGajiTahunDepan: "",
      },
      selected: null,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataGaji, null, 4);
    },
    isValid() {
      return !this.$v.dataGaji.$invalid;
    },
    isDirty() {
      return this.$v.dataGaji.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataGaji: {
      namaGaji: {
        required,
      },
      nominalGaji: {
        required,
        numeric,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataGaji[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    convert(x) {
      // console.log(x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))
      return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("masterGaji/register", vm.dataGaji)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$v.$reset();
              vm.$emit("alert", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER GAJI POKOK",
                showing: true,
              });
              this.$bvModal.hide("modal-input-gaji");
              this.reset();
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alert", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch(() => {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
    reset() {
      this.$v.$reset();
      this.dataGaji = {
        namaGaji: "",
        nominalGaji: "",
      };
    },
  },
};
</script>
